import React from "react";

export function TimerStyles(params = {}) {
    const { palette } = params;

    return {
        // !TODO
        "@global": {
            ".timer": {
                position: "fixed",
                left: 0,
                right: 0,
                bottom: 0,
                zIndex: "2048",

                display: "grid",
                justifyContent: "center",

                width: "100%",
                pointerEvents: "none",
                textAlign: "center",

                ".timer-content": {
                    display: "grid",
                    gridAutoFlow: "column",
                    alignItems: "center",
                    gridTemplateColumns: "1fr 1fr 1fr 1fr",

                    height: "104px",
                    width: "366px",
                    border: "2px solid #000000",
                    background: palette.primary.initial,
                    color: palette.primary.initialText,

                    ".timer-separator": {
                        position: "absolute",
                        fontSize: "32px",
                        fontWeight: "900",
                        color: palette.primary.initialText,
                    },
                },

                ".timer-item": {
                    display: "grid",
                    gridAutoFlow: "column",
                    color: palette.primary.initialText,

                    ".timer-item-time": {
                        fontSize: "32px",
                        fontWeight: "900",
                        gridRow: 1,
                    },

                    ".timer-item-text": {
                        fontSize: "15px",
                        fontWeight: "400",
                        gridRow: 2,
                    },
                },
            },
        },
    };
}

export default function Timer(props) {
    const refTimerWrap = React.useRef(null);

    const refDays = React.useRef(null);
    const refHours = React.useRef(null);
    const refMinutes = React.useRef(null);
    const refSeconds = React.useRef(null);

    if (!props.deadlineDate) {
        return null;
    }

    const deadlineTime = props?.deadlineTime.split(":");
    const deadlineTimeMS = deadlineTime[0] * 60 * 60 * 1000 + deadlineTime[1] * 60000;
    const deadline =
        props.deadlineDate - Math.abs(new Date(props.deadlineDate).getTimezoneOffset() * 60000) + deadlineTimeMS;

    React.useEffect(() => {
        const getTime = () => {
            const time = deadline - Date.now();

            if (time <= 0) {
                return;
            }

            refDays.current.innerHTML = Math.floor(time / (1000 * 60 * 60 * 24));
            refHours.current.innerHTML = Math.floor((time / (1000 * 60 * 60)) % 24);
            refMinutes.current.innerHTML = Math.floor((time / 1000 / 60) % 60);
            refSeconds.current.innerHTML = Math.floor((time / 1000) % 60);
        };

        const interval = setInterval(() => getTime(deadline), 1000);

        getTime(deadline);

        return () => {
            clearInterval(interval);
        };
    }, [deadline]);

    React.useEffect(() => {
        const domTimer = refTimerWrap?.current?.children?.[0];

        if (!domTimer) {
            return;
        }

        if (domTimer.parentElement !== document.body) {
            document.body.appendChild(domTimer);
        }

        return () => {
            if (domTimer && domTimer?.parentElement) {
                domTimer.parentElement.removeChild(domTimer);
            }
        };
    }, []);

    const CNTimer = ["timer-content"];

    return (
        <div ref={refTimerWrap}>
            <div className="timer" data-deadline={deadline}>
                <div className={CNTimer.join(" ")}>
                    <div className="timer-item">
                        <div ref={refDays} className="timer-item-time days">
                            -
                        </div>
                        <div className="timer-item-text">d</div>
                    </div>

                    <div className="timer-item">
                        <div ref={refHours} className="timer-item-time hours">
                            -
                        </div>
                        <div className="timer-item-text">h</div>
                    </div>

                    <div className="timer-item">
                        <div className="timer-separator">:</div>
                        <div ref={refMinutes} className="timer-item-time minutes">
                            -
                        </div>
                        <div className="timer-item-text">m</div>
                    </div>

                    <div className="timer-item">
                        <div className="timer-separator">:</div>
                        <div ref={refSeconds} className="timer-item-time seconds">
                            -
                        </div>
                        <div className="timer-item-text">s</div>
                    </div>
                </div>
            </div>
        </div>
    );
}
